import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import User from "../../../model/user/User";
import {none, Option, option} from "ts-option";
import PartnerBrandUserTPIESelector from "../../lead/v4/partnerBrandUser/PartnerBrandUserTPIESelector";

interface ComponentProps {
	/**
	 * Partner brand identifier.
	 */
	partnerBrandId: Option<string>;
}

type Props = ComponentProps & FormGroupProps<string>;

/**
 * Lead user selector form view group.
 */
export default class LUSelectorFormGroup extends React.PureComponent <Props> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<PartnerBrandUserTPIESelector
					customRoleTitle={"LU"}
					partnerBrandId={this.props.partnerBrandId}
					partnerBrandUserId={this.props.field.getOptionalValue()}
					removable={this.props.field.getOptionalValue().isDefined}
					onRemoveClick={this.onRemove}
					onChange={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Remove selection
	 */
	onRemove = () => {
		this.props.onChange(this.props.field.updateValue(none))
	};
	/**
	 * Callback on lead user changed.
	 * @param user
	 */
	onChange = (user: User) => {
		this.props.onChange(this.props.field.updateValue(option(user.id)));
	}
}